import React, { useContext } from "react";
import Button from "../../../../components/ButtonComponent/Button";
import { SideMenu } from "../../../../components/sideMenu/SideMenu";
import { ResetPasswordContext } from "../ResetPasswordView";
import TextContent from "../.././../../constants/contentFile.json";
import { InputBox } from "../../../../components/InputField/inputFiled";
import EyeVisible from "../../../../assests/images/eyeVisible.svg";
import EyeInVisible from "../../../../assests/images/eyeInVisible.svg";
import AlertBox from "../../../../components/alertComponent/AlertBox";
import "./ResetPassword.css";

const ResetPassword = () => {
  const {
    submitnewPassword,
    oldPassword,
    handleAlertSubmit,
    oldPasswordInvalid,
    setOldPassword,
    newPassword,
    buttonFunction,
    setNewPassword,
    PasswordConfirm,
    setShowAlert,
    alertMessage,
    setPasswordConfirm,
    newPasswordType,
    showAlertReset,
    setShowAlertReset,
    setNewPasswordType,
    passwordType,
    logout,
    setPasswordType,
    confirmPasswordType,
    setConfirmPasswordType,
    newPasswordInvalid,
    showAlert,
    confirmPasswordInvalid,
    passWordMisMatch,
    setShowLogoutAlert,
    showLogoutAlert,
    logoutConstants,
    logoutAlertMessage,
  } = useContext(ResetPasswordContext);
  console.log('buttonFunction__', buttonFunction)
  console.log('show alert', showAlert)
  return (
    <div className="mainContainerDetail">
      <SideMenu />
      <div className="itemBoxDetail resetPasswordOut">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mainBoxDetail ">
          <div className="resetPasswordHead">
              <h6>{TextContent.resetPassword.resetPassword}</h6>
          </div>
          <div className="row">
            <div className="col-xl-4 col-lg-12 col-md-12">
            <div className="resetPasswordSection">
              <h6>{TextContent.resetPassword.currentPassword}</h6>
              <div className="inputData">
              <InputBox
                value={oldPassword}
                type={passwordType}
                placeholder={
                  TextContent.resetPassword.currentPasswordPlaceholder
                }
                onChange={(e) => {
                  setOldPassword(e.target.value);
                }}
              />
              {passwordType === "password" ? (
                <i className="bi bi-eye-slash">
                  <img
                    src={EyeVisible}
                    onClick={() => {
                      setPasswordType("text");
                    }}
                  />
                </i>
              ) : (
                <i className="bi bi-eye-slash">
                  <img
                    src={EyeInVisible}
                    onClick={() => {
                      setPasswordType("password");
                    }}
                  />
                </i>
              )}
              </div>

              {oldPasswordInvalid ? (
                <div className="invalid-textDispaly">
                  Please enter old password
                </div>
              ) : (
                ""
              )}

            </div>
            </div>

            <div className="col-xl-4 col-lg-12 col-md-12">
            <div className="resetPasswordSection">
              <h6>{TextContent.resetPassword.newPassword}</h6>
              <div className="inputData">
              <InputBox
                value={newPassword}
                type={newPasswordType}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
                placeholder={TextContent.resetPassword.newPasswordPaceholder}
              />
              {newPasswordType === "password" ? (
                <i className="bi bi-eye-slash">
                  <img
                    src={EyeVisible}
                    onClick={() => {
                      setNewPasswordType("text");
                      // setPasswordType("text");
                    }}
                  />
                </i>
              ) : (
                <i className="bi bi-eye-slash">
                  <img
                    src={EyeInVisible}
                    onClick={() => {
                      setNewPasswordType("password");
                      // setPasswordType("password");
                    }}
                  />
                </i>
              )}
              </div>
              {newPasswordInvalid ? (
                <div className="invalid-textDispaly">
                  Please enter new password
                </div>
              ) : (
                ""
              )}

            </div>
            </div>
            <div className="col-xl-4 col-lg-12 col-md-12">
            <div className="resetPasswordSection">
              <h6>{TextContent.resetPassword.confirmPassword}</h6>
              <div className="inputData">
              <InputBox
                value={PasswordConfirm}
                type={confirmPasswordType}
                onChange={(e) => {
                  setPasswordConfirm(e.target.value);
                }}
                placeholder={
                  TextContent.resetPassword.confirmPasswordPlaceholder
                }
              />
              {confirmPasswordType === "password" ? (
                <i className="bi bi-eye-slash">
                  <img
                    src={EyeVisible}
                    onClick={() => {
                      setConfirmPasswordType("text");
                    }}
                  />
                </i>
              ) : (
                <i className="bi bi-eye-slash">
                  <img
                    src={EyeInVisible}
                    onClick={() => {
                      setConfirmPasswordType("password");
                    }}
                  />
                </i>
              )}
              </div>
              
              {passWordMisMatch ? (
                <div className="invalid-textDispaly">
                  Passwords do not match
                </div>
              ) : (
                ""
              )}
              {confirmPasswordInvalid ? (
                <div className="invalid-textDispaly">
                  Please enter confirm password
                </div>
              ) : (
                ""
              )}


            </div>
     
          </div>
          </div>
          <div className="buttonContainerDetails">
              <div className="buttonContainerAccept">
              <Button
                  text={"SUBMIT"}
                  onClick={() => {
                    submitnewPassword();
                  }}
                ></Button>
              </div>
            </div>
          {/* <div className="subnitCancelBtns btn-right">
              <div lassName="buttonCancel">
                <Button
                  text={"SUBMIT"}
                  onClick={() => {
                    submitnewPassword();
                  }}
                ></Button>
              </div>
            </div> */}
            <AlertBox
                      alertMessage={alertMessage}
                      show={showAlert}
                      setShow={setShowAlert}
                      alertFunc={() => handleAlertSubmit()}
            />
            <AlertBox
            show={showAlertReset}
            setShow={setShowAlertReset}
            alertMessage={alertMessage}
            title={"Alert"}
            buttonSubmitText={"LOGIN"}
            alertFunc={() => {
              logout();
            }}
            />
                    <AlertBox
          show={showLogoutAlert}
          setShow={setShowLogoutAlert}
          title={logoutConstants.alert}
          alertMessage={logoutAlertMessage}
        />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
